
class DesignerApp {
  constructor() {
    this.designName = "untitled";
    this.designNamePrefix = "customizer-";
    this.textObjects = new Array();
    this.boardImage = null;
    this.baseBoard = null;
    this.selectedNode = null;
    this.intervalId = null;
    this.pressTimer = null;
    this.dropZone = null;

    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.sceneWidth = this.width;
    this.sceneHeight = this.height;

    this.boardDimensions = {
      board: { width: 0, height: this.height },
      base: { width: 0, height: this.height },
      transformer: { width: 0, height: 0 },
      boardFeet: { total: 0 }
    };

    // Konva Setup
    this.stage = new Konva.Stage({
      container: "container",
      width: this.width,
      height: this.height,
      draggable: true,
    });

    this.layer = new Konva.Layer();
    this.stage.add(this.layer);
    
    // Transformers
    this.baseimagetransformer = this.createBaseImageTransformer();
    this.createTransformerMoveIcon()
    this.layer.add(this.getBaseImageTransformer());
    
    this.transformer = this.createTransformer();
    this.layer.add(this.getTransformer());

    this.bindEvents();


    this.fileMenu = new DesignerFileMenu({app: this});
    this.imagesMenu = new DesignerImagesMenu({app: this});
    this.textMenu = new DesignerTextMenu({app: this});
    this.editMenu = new DesignerEditMenu({app: this});
    this.helpMenu = new DesignerHelpMenu({app: this});
    this.contextMenu = new ContextMenu({app: this});
    this.fontChanger = null;


    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.init();
      });
    } else {
      this.init();
    }

    /*
    this.signals = {
      nodeSelected: new Signal(),
      nodeDeselected: new Signal(),
      nodeAdded: new Signal(),
      nodeRemoved: new Signal(),
      nodeMoved: new Signal(),
      nodeResized: new Signal(),
      nodeRotated: new Signal(),
      nodeChanged: new Signal(),

      designNew: new Signal(),
      designOpened: new Signal(),
      designSaved: new Signal(),
      designDeleted: new Signal(),
    };


    

    this.signals.designNew.add( function () {
      console.log("signal caught - designNew");
    });
    */

  }




  getBoard() {
    let baseLayer = this.getBaseLayer();
    let ret = null;

    if (baseLayer) {
      customizer_boards.forEach((board) => {
        if (removeFileExtension(board.board_image) === removeFileExtension(baseLayer.attrs.name)) {
          ret = board;
        }
      });
    }

    return ret;
  }

  
  getLayer() {
    return this.layer;
  }


  getStage() {
    return this.stage;
  }


  getBaseImageTransformer() {
    return this.baseimagetransformer;
  }


  getTransformer() {
    return this.transformer;
  }


  getBaseLayer() {
    var matched = this.getLayer().getChildren(function (node) {
      return node.getClassName() === "Image" && node.attrs.type === "baseImage";
      //return node.getClassName() === "BaseLayer";
    });

    if (matched && matched.length) {
      matched = matched[0];
    } else {
      matched = null;
    }

    return matched;
  }


  getBoardImage() {
    return this.getBaseLayer();
  }

  
  getDesignName() {
    return this.designName;
  }


  setDesignName(name) {
    this.designName = name;
  }

  getDesignNamePrefix() {
    return this.designNamePrefix;
  }


  setDropZone(dropZone) {
    this.dropZone = dropZone;
  }


  getDropZone() {
    return this.dropZone;
  }


  
  
  
  setBaseBoardConfig(config) {
    baseBoardConfig = {
      canChooseTrack: parseBoolean(config.canChooseTrack) ?? null,
      width: config.width ?? null,
      length: config.length ?? null,
    };
  }


  createBaseImageTransformer() {
    let baseRotateSnaps = [];
    for (let r = 0; r < 360; r += 90) {
      baseRotateSnaps.push(r);
    }

    const transformer = new Konva.Transformer({
      selectable: false,
      flipEnabled: false,
      rotationSnaps: baseRotateSnaps,
      rotationSnapTolerance: 45,
      rotateAnchorOffset: 25,
      enabledAnchors: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
      anchorStyleFunc: (anchor) => {
        anchor.cornerRadius(10);
        if (anchor.hasName("top-center") || anchor.hasName("bottom-center")) {
          anchor.height(6);
          anchor.offsetY(3);
          anchor.width(20);
          anchor.offsetX(13);
        } else if (anchor.hasName("middle-left") || anchor.hasName("middle-right")) {
          anchor.height(26);
          anchor.offsetY(13);
          anchor.width(6);
          anchor.offsetX(3);
        } else if (anchor.hasName("rotater")) {
          anchor.cornerRadius(10);
          anchor.width(20);
          anchor.height(20);
          anchor.offsetX(10);
          anchor.offsetY(10);
        } else {
          anchor.width(14);
          anchor.offsetX(8);
          anchor.height(14);
          anchor.offsetY(8);
        }
      },
      boundBoxFunc: (oldBox, newBox) => {
        // Using global config constants: resizeIncrement, inch, maxBaseBoardWidth, maxBaseBoardHeight
        newBox.width = Math.round(newBox.width / (resizeIncrement * this.getStage().scaleX())) * (resizeIncrement * this.getStage().scaleX());
        newBox.height = Math.round(newBox.height / (resizeIncrement * this.getStage().scaleY())) * (resizeIncrement * this.getStage().scaleY());

        if (newBox.width < inch) newBox.width = inch * this.getStage().scaleX();
        if (newBox.height < inch) newBox.height = inch * this.getStage().scaleY();

        if (newBox.width > inch * maxBaseBoardWidth * this.getStage().scaleX()) newBox.width = inch * maxBaseBoardWidth * this.getStage().scaleX();
        if (newBox.height > inch * maxBaseBoardHeight * this.getStage().scaleX()) newBox.height = inch * maxBaseBoardHeight * this.getStage().scaleY();

        return newBox;
      },
    });

    transformer.on('transformend', () => {
      this.updateBaseLayerDimensions(transformer.size());
    });
    
    transformer.rotateEnabled(true);

    return transformer;
  }


  createTransformer() {
    const transformer = new Konva.Transformer({
      selectable: false,
      rotationSnaps: rotSnaps, // global from DesignerConfig.js
      shouldOverdrawWholeArea: true,
    });
    
    transformer.on("transform", () => {
      updateProperties();
    });

    transformer.on("transformed", () => {
      updateProperties();
    });
    
    return transformer;
  }  


  createTransformerMoveIcon() {
    const mySvgData = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#36B1F7"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"/></svg>';
    const svgDataUrl = svgToDataURL(mySvgData);

    Konva.Image.fromURL(svgDataUrl, (imageNode) => {
      // Set desired position and size for your icon
      imageNode.setAttrs({
        x: -19,
        y: -19,
        width: 36, // Adjust as needed
        height: 36, // Adjust as needed
        selectable: false,
      });

      // Add the image to your Konva layer
      this.getBaseImageTransformer().add(imageNode);
    });
  }


  bindEvents() {
    window.addEventListener('resize', () => {
      this.handleWindowResize();
    });

    document.addEventListener('keydown', this.handleKeyPress.bind(this));
  }


  handleKeyPress(event) {
    if (event.key === 'Delete') {
      this.handleDeleteItem();
    } else if (event.key === 'Insert') {
      this.createTextNode({});
    } else if (event.key === 'Escape') {
      this.selectNone();
    }
  }


  handleDeleteItem() {
    let sel = this.getSelectedNode();

    if (sel && sel.attrs.type == "baseImage") {
      showMessage("Notice", "You can no delete the Cribbage board. Please select a new Cribbage board if this is not the one you want.")
    } else if (sel) {
      let selIdx = this.getNodeIndex(sel);
      this.selectNone();
      this.deleteNode(sel);

      if (selIdx + 1 > this.getLayer().children.length) {
        selIdx = this.getLayer().children.length - 1;
        selIdx = this.getFirstSelectableNodeIndex();
      }

      if (selIdx != -1) {
        this.selectNode(this.getLayer().children[selIdx]);
      }

      updateProperties();
    }
  }


  createTextNode() {
    this.textMenu.createTextNode({});
  }


  async init() {
    // Show Help Dialog
    if (localStorage.getItem('hasViewedHelp') != 'true') {
      localStorage.setItem('hasViewedHelp', 'true');
      document.getElementById("helpDialog").showModal();
    }

    // Close Dialogs
    document.querySelectorAll(".closeDialog").forEach((btn) => {
      btn.addEventListener("click", (evt) => {
        btn.parentNode.parentNode.close();
      });
    });

    document.addEventListener('DOMContentLoaded', function() {
      try { if (typeof initDropdownMenus === 'function') initDropdownMenus(); } catch (e) { console.error("initDropdownMenus failed", e); }
      try { if (typeof initSidebar === 'function') initSidebar(); } catch (e) { console.error("initSidebar failed", e); }
      try { if (typeof initButtons === 'function') initButtons(); } catch (e) { console.error("initButtons failed", e); }
    });
    

    initDropdownMenus();
    initSidebar();
    initButtons();
    this.initStains();
    this.initDropZone();
    const dragSnap = new DragSnap({ app: this });
    
    setTimeout(() => {
      this.fontChanger = new FontChanger({ customSelect: document.getElementById("fontFamily"), app: this });
    }, 3000);

    const designDocument = document;


    
    // Handle selecting nodes
    this.getStage().on("click tap", (e) => {
      let isCtrl = e.evt.ctrlKey;
      //console.log("stage click tap", e);

      // if click on empty area or on the transformer itself
      if (
        e.target === this.getStage() ||
        e.target === this.getLayer() ||
        e.target.getParent() === this.getTransformer() 
      ) {
        this.getLayer().draw();
        this.selectNone();
        return;
      }

      this.selectNode(e.target, isCtrl);
    });


    // scale up and down with mouse wheel
    this.getStage().on("wheel", (e) => {
      let isShift = e.evt.shiftKey;
      let scaleObj = null;

      //console.log("stage wheel", e);  
      //debugger;

      e.evt.preventDefault(); // Prevent page scrolling
      let sel = this.getSelectedNode();

      //console.log(sel);

      if (!sel || e.target === this.getStage()) {
        sel = this.getStage();
      }

      let canResizeNode = this.canResize(sel);

      //console.log(canResizeNode);

      if (canResizeNode) {
        /*
        if (!sel) {
          scaleObj = this.getStage();
        } else if (sel && sel.className == "Image") {
          scaleObj = sel;
        }
        */
        scaleObj = sel;

        const oldScale = scaleObj.scaleX();
        const pointer = this.getStage().getPointerPosition();

        // Calculate pointer position relative to the scaleObj's current viewport
        const mousePointTo = {
          x: (pointer.x - scaleObj.x()) / oldScale,
          y: (pointer.y - scaleObj.y()) / oldScale,
        };

        let newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;

        // Optional: Set min/max zoom levels
        const minScale = 0.1;
        const maxScale = 10;
        newScale = Math.max(minScale, Math.min(newScale, maxScale));

        // Calculate new scaleObj position to keep the pointer fixed
        const newPos = {
          x: pointer.x - mousePointTo.x * newScale,
          y: pointer.y - mousePointTo.y * newScale,
        };

        scaleObj.scale({ x: newScale, y: newScale });
        scaleObj.position(newPos);
        this.getLayer().draw();
        this.updateBaseLayerDimensions(this.getBaseImageTransformer().size());
        
      } else if (sel.className != "Image") {
          let dir = e.evt.deltaY > 0 ? 1 : -1;
          if (isShift) 
            dir = dir * 10;
          
        if (sel.attrs.type === "text") {         
          sel.setFontSize(sel.getFontSize() - dir);
          updateProperties();

        } else if (sel.attrs.type === "shape") {
          if (sel.width != undefined) {
            if (sel.getWidth() - dir >= 10) {
              sel.setWidth(sel.getWidth() - dir);
            }
          } 
          
          if (sel.height != undefined) {
            if (sel.getHeight() - dir >= 10) {
              sel.setHeight(sel.getHeight() - dir);
            }
          }
          
          if (sel.setRadiusX != undefined) {
            sel.setRadiusX(sel.getRadiusX() - dir);
            sel.setRadiusY(sel.getRadiusY() - dir);

          } else if (sel.setInnerRadius != undefined) {
            sel.setInnerRadius(sel.getInnerRadius() - dir);
            sel.setOuterRadius(sel.getOuterRadius() - dir);

          } else if (sel.setRadius != undefined) {
            if (sel.getRadius() - dir >= 10) {
              sel.setRadius(sel.getRadius() - dir);
            }
          }

          if (sel.getClassName() === "Arrow") {
            sel.setPoints([0, 0, sel.getPoints()[2] - dir, 0]);

          }

          updateProperties();
        }

      }
    });




    if (window.location.search && window.location.search.trim() != '') {
      let urlParams = getParamsFromUrl(window.location.search); // global from utils? No, generic util

      if (urlParams && urlParams.design != undefined) {
        this.fileMenu.loadPrebuiltDesign(urlParams.design);
      } else if (urlParams && urlParams.board != undefined) {
        this.loadBaseBoard(urlParams.board);
      }
    } else if (autoLoadDesign === true) {
      const defaultBoard = document.querySelector(".boardImage[title='Baltic Birch Plywood - 15x15 Square']");
      if (defaultBoard) defaultBoard.click();
    }
  }


  handleWindowResize() {
    this.getStage().width(window.innerWidth);
    this.getStage().height(window.innerHeight);
    this.fitLayerToStage();
    this.layer.draw();
  }


  fitLayerToStage() {
    const stageWidth = this.getStage().width();
    const stageHeight = this.getStage().height();
    
    // Get the bounding box of all content in the layer
    const contentRect = this.getLayer().getClientRect({
      skipTransform: true, // Ignore current layer scale for accurate bounds
    });

    // Calculate scale to fit content within stage
    const scaleX = stageWidth / contentRect.width;
    const scaleY = stageHeight / contentRect.height;
    const scale = Math.min(scaleX, scaleY); // Preserve aspect ratio

    // Apply scale to layer
    this.getLayer().scale({ x: scale, y: scale });

    // Center the content
    const scaledWidth = contentRect.width * scale;
    const scaledHeight = contentRect.height * scale;

    this.getLayer().x((stageWidth - scaledWidth) / 2 - contentRect.x * scale);
    this.getLayer().y((stageHeight - scaledHeight) / 2 - contentRect.y * scale);
    this.getLayer().batchDraw();
  }


  updateBaseLayerDimensions(newBox) {
    let boardDims = {
      width: Math.round(newBox.width / (inch * this.getStage().scaleX())),
      height: Math.round(newBox.height / (inch * this.getStage().scaleY()))
    };
    let baseDims = {
      width: this.getBaseLayer() ? this.getBaseLayer().width() : 0,
      height: this.getBaseLayer() ? this.getBaseLayer().height() : 0
    };
    let transDims = {
      width: parseInt(newBox.width),
      height: parseInt(newBox.height)
    };
    let boardFeet = Math.ceil((boardDims.width * boardDims.height) / boardFeetInches); // global boardFeetInches

    this.boardDimensions.board = boardDims;
    this.boardDimensions.base = baseDims;
    this.boardDimensions.transformer = transDims;
    this.boardDimensions.boardFeet.total = boardFeet;

    if (this.boardImage) {
        const boardContent = document.querySelector(".board-content");
        if (boardContent) {
             boardContent.innerHTML = `Board Details<br>Width: ${this.boardDimensions.board.width}"<br>Height: ${this.boardDimensions.board.height}"<br>Price: $${this.calculateDesignCost()}`;
        }
    }
  }


  loadBaseImage(imgName, config = {}) {
    //console.log("loadBaseImage loading", baseUrl + imgName);  
    Konva.Image.fromURL(baseUrl + imgName, (image) => {
      //console.log("loadBaseImage loaded", baseUrl + imgName, config);  
      image.setAttrs({
        x: config.x ?? 60 + image.width() / 2,
        y: config.y ?? 60 + image.height() / 2,
        name: imgName,
        type: "baseImage",
        draggable: false,
        scaleX: config.scaleX ?? 1,
        scaleY: config.scaleY ?? 1,        
      });

      const scale = this.scaleDownToImage(image);
      this.getStage().scale({ x: scale, y: scale });

      image.offset({
        x: image.width() / 2,
        y: image.height() / 2,
      });

      this.boardImage = image;
      this.getLayer().add(image);
      // layer.children[layer.children.length - 1].moveToBottom(); 
      // Better way to move to bottom if children exist
      image.moveToBottom();
      
      this.getBaseImageTransformer().nodes([image]);

      setTimeout(() => {
        this.updateBaseLayerDimensions(this.getBaseImageTransformer().size());
        updateProperties();
      }, 2000);

      if (this.baseBoard) {
        if (!this.baseBoard.can_resize) {
          this.getBaseImageTransformer().enabledAnchors(['top-center']);
        } else {
          this.getBaseImageTransformer().enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
        }
      }
    });
  }


  scaleDownToImage(image) {
      const currentWidth = image.width();
      const currentHeight = image.height();
      const padding = 50;
      const maxWidth = this.getStage().width() - 2 * padding;
      const maxHeight = this.getStage().height() - 2 * padding;

      if (currentWidth <= maxWidth && currentHeight <= maxHeight) {
        return 1; // Return 1 if no scaling needed (default scale)
      }

      const scaleToFitWidth = maxWidth / image.width();
      const scaleToFitHeight = maxHeight / image.height();
      let targetScale = Math.min(scaleToFitWidth, scaleToFitHeight);

      let targetWidth = image.width() * targetScale;
      let targetHeight = image.height() * targetScale;
      let scaleInc = 72 * this.getStage().scaleX();

      targetWidth = Math.floor(targetWidth / scaleInc) * scaleInc;
      targetHeight = Math.floor(targetHeight / scaleInc) * scaleInc;

      if (targetWidth < scaleInc) targetWidth = scaleInc;
      if (targetHeight < scaleInc) targetHeight = scaleInc;

      const newScaleX = targetWidth / image.width();
      const newScaleY = targetHeight / image.height();
      return Math.min(newScaleX, newScaleY);
  }
  // Pending implementation
  newDesign() { 
    this.fileMenu.newDesign();
  }


  loadBaseBoard(name) { 
      // logic from designer.js loadBaseBoard
      // Customizer boards global?
      if (typeof this.getCustomizerBoards() !== 'undefined') {
          this.getCustomizerBoards().forEach(board => {
            if (board.name.toLowerCase().trim() == name.toLowerCase().trim()) {
              this.loadBaseImage(board.board_image);
            }
          });
      }
  }
  

  getCustomizerBoards() {
    return customizer_boards;
  }


  getBaseBoard(name) {
    let ret = null;

    this.getCustomizerBoards().forEach(board => {
      if (board.name.toLowerCase().trim() == name.toLowerCase().trim()) {
        ret = board;
      }
    });

    return ret;
  }


  //loadPrebuiltDesign(name) { loadPrebuiltDesign(name); } // defer to global for now
  //updateProperties() { updateProperties(); } // defer to global






  selectNone() {
    this.selectedNode = null;
    //this.selectNode(null);
    this.getTransformer().nodes([]);
    updateProperties();
  }  


  selectNode(node, isCtrl = false) {
    //debugger;
    //console.log("select Node", {node: node, selectedNode: selectedNode});
    //console.log("isGrouped", isNodeGrouped(node));

    if (node === this.selectedNode) {
      //console.log("Can't select the same node");
      return;
    }

    if (node && this.isNodeGrouped(node)) {
      node = node.parent;
    }

    if (node && node.parent && node.parent.className === "MultiPathSVGGroup") {
      node = node.parent;
    }

    // Don't allow selecting transformer nodes
    if (node && node.getClassName() === "Transformer") {
      //console.log("Can't select a transformer node");
      return;
    }

    // Don't allow selecting non-selectable nodes
    if (node && node.attrs && node.attrs.selectable != undefined && node.attrs.selectable === false) {
      //console.log("This node is not selectable");
      //console.log("node", node);
      //console.log("node.attrs", node.attrs);  
      //console.log("node.attrs.selectable", node.attrs.selectable);  
      return;
    }

    if (isCtrl && this.selectedNode._id != node._id) {
      this.groupNodes(this.selectedNode, node);
      return;
    }

    if (this.selectedNode && this.selectedNode.setDraggable) {
      this.selectedNode.setDraggable(false);
    }

    if (this.selectedNode &&
      (this.selectedNode.getClassName() === "QuadraticTextPathGroup" ||
        this.selectedNode.getClassName() === "BezierTextPathGroup")
    ) {
      this.selectedNode.hideControls();
    }


    if (node && node.getClassName() != "Transformer" && (node.parentNode && node.parentNode.getClassName() != "Transformer") && node.parent != null && node.parent.nodeType === "Group") {
      //node = node.parent;
      //console.log("selecting parent node", node, node.parent, node.parent.nodeType, node.parent.getClassName());

      let selParent = node.parent;
      if (selParent.parent.nodeType === "Group" && selParent.parent.getClassName() != "Transformer") {
        //console.log("selecting parent parent node", node.parent);
        selParent = selParent.parent;
      }

      //console.log("selected parent node", selParent);
      node = selParent;
      //selectNode(node.parent);
    }

    //console.log("selectNode", node); 
    if (node && node.attrs && node.attrs.selectable != undefined && node.attrs.selectable === false) {
      //return;
    }

    if (node == this.getBaseLayer()) {
      return;
    }

    this.selectedNode = node;
    //console.log("selected node", selectedNode, node);
    updateProperties();

    if (node) {
      if (this.selectedNode &&
        (this.selectedNode.getClassName() === "QuadraticTextPathGroup" ||
          this.selectedNode.getClassName() === "BezierTextPathGroup")
      ) {
        this.selectedNode.showControls();
      }

      this.selectedNode.setDraggable(true);
      //console.log("Adding node to transformer", selectedNode);
      this.getTransformer().nodes([this.selectedNode]);

      //console.log("Updating Node Properties");
      updateProperties();

      let canResizeNode = this.canResize(node);
      console.log("canResizeNode", canResizeNode, node);
      this.getTransformer().resizeEnabled(canResizeNode);

      if (canResizeNode === true) {
        //transformer.enabledAnchors(['bottom-right']);
        this.getTransformer().enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
      } else {
        this.getTransformer().enabledAnchors([]);
      }

      //transformer.resizeEnabled(true);
      //transformer.enabledAnchors(['bottom-right']);


    } else {
      this.getTransformer().nodes([]);

    }

    return this.selectedNode;
  }


  selectNodeById(id) {
    const findRecursive = (parent) => {
      if (parent._id === id) return parent;
      if (parent.children) {
        for (let child of parent.children) {
          let res = findRecursive(child);
          if (res) return res;
        }
      }
      return null;
    }

    let node = findRecursive(this.getLayer());
    if (node) {
      this.selectNode(node);
    }
  }


  isNodeGrouped(node) {
    return node && node.parent && node.parent.getClassName() === "Group";
  }


  groupNodes(node1, node2) {
    /*
    if (node1.getClassName() === "BaseLayer"  || 
        node1.getClassName() === "Track"      ||
        node1.getClassName() === "Group"      ||
        node2.getClassName() === "BaseLayer"  || 
        node1.getClassName() === "Track"      ||
        node2.getClassName() === "Group") {
      return;
    }
    */

    if (node1.getClassName() === "Group" || node2.getClassName() === "Group") {
      if (node1.getClassName() === "Group") {
        node2.moveTo(node1);
        this.selectNode(node1);
      } else {
        node1.moveTo(node2);
        this.selectNode(node2);
      }
    } else {
      let tg = new Konva.Group({ draggable: true })

      node1.moveTo(tg);
      node2.moveTo(tg);
      this.getTransformer().nodes([tg]);

      tg.children.forEach(child => {
        child.attrs.draggable = false;
        child.setDraggable(false);
      });

      this.getLayer().add(tg)
      this.selectNode(tg);
    }
  }


  ungroupNode(node) {
    //console.log("ungroupNode", node);

    if (node && node.getClassName() === "Group" && node.children.length) {
      const children = [...node.children];

      children.forEach(child => {
        child.attrs.draggable = true;
        child.setDraggable(true);

        const absolutePosition = child.getAbsolutePosition();
        child.moveTo(this.getLayer());
        child.setAbsolutePosition(absolutePosition);
      });

      if (node === this.getSelectedNode()) {
        this.selectNone();
      }

      node.destroy();
      this.getLayer().batchDraw();
      this.updateLayers();
    }
  }


  getSelectedIndex() {
    let ret = null
    if (this.getSelectedNode()) {
      ret = this.getSelectedNode().index;
    }
    return ret;
  }


  getFirstObjectIndex() {
    let items = this.getLayer().getChildren();
    let ret = null;
    let pos = 0;

    items.forEach((item) => {
      if (item.attrs.type != "baseImage" && item.className != "Transformer") {
        if (ret == null) {
          ret = pos;
        }
      }
      pos++;
    });

    return ret;
  }


  canResize(node) {
    let canResizeNode = false;

    if (node && node.getClassName && node.getClassName() === "Stage") {
      canResizeNode = true;
      return canResizeNode;
    }

    //console.log("selectnode", node.attrs.type, node.attrs?.type.toLowerCase(), node.attrs.group)

    if (node && node.attrs && node.attrs.type) {
      switch (node.attrs?.type.toLowerCase() ?? "unknown") {
        case "baseimage":
          canResizeNode = false;
          break;
        case "text":
          canResizeNode = false;
          break;
        case "textpath":
          canResizeNode = true;
          break;
        case "imageupload":
          canResizeNode = true;
          break;
        case "svgupload":
          canResizeNode = true;
          break;
        case "svgobject":
          if (node.attrs.group === "Tracks") {
            canResizeNode = false;
          } else if (node.attrs.group === "Parts") {
            canResizeNode = false;
          } else {
            canResizeNode = true;
          }
          break;
        case "multipathsvggroup":
          if (node.attrs.group === "Tracks") {
            canResizeNode = false;
          } else if (node.attrs.group === "Parts") {
            canResizeNode = false;
          } else {
            canResizeNode = true;
          }
          break;
        case "cutout":
          canResizeNode = true;
          break;
        case "beziertextpathgroup":
          canResizeNode = false;
          break;
        case "quadratictextpathgroup":
          canResizeNode = false;
          break;
        case "sinewavetextpath":
          canResizeNode = false;
          break;
        case "circletextpath":
          canResizeNode = false;
          break;
        case "ellipsetextpath":
          canResizeNode = false;
          break;
        case "sidedtextpath":
          canResizeNode = false;
          break;
        case "rectangletextpath":
          canResizeNode = false;
          break;
        case "spiraltextpath":
          canResizeNode = false;
          break;
        case "squarespiraltexpath":
          canResizeNode = false;
          break;
      }
    }

    //console.log("canResize", canResizeNode);

    return canResizeNode;
  }


  updateLayers() {
    let items = this.getSortableNodes();
    //console.log("updateLayers", items);

    const listContainer = document.querySelector('.layerListContainer');

    // Dynamically create list items from the array
    listContainer.innerHTML = '';
    let layerIdx = 1;

    const addItems = (nodes, container, level = 0) => {
      nodes.forEach(item => {
        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.classList.add('layer-group-wrapper');
        wrapper.setAttribute('draggable', level === 0 ? 'true' : 'false');
        wrapper.setAttribute('data-id', item._id);

        const listItem = document.createElement('div');
        listItem.classList.add('list-item-layer');
        //listItem.setAttribute('draggable', 'true'); // Wrapper is now draggable
        listItem.setAttribute('data-id', item._id);

        // Indentation
        listItem.style.marginLeft = (level * 20) + 'px';

        let visible = item.visible() == true ? "" : "layer-hidden";
        let isText = item.copySVGDataToClipboard != undefined ? "" : "hidden";
        let visible_class = item.visible() == true ? "visibility" : "visibility_off";

        listItem.innerHTML = `
            <span class="material-icons drag-handle-layer">drag_indicator</span>
            <span class="item-text-layer">${item.getClassName()} ($${this.calculateLayerCost(item)})</span>
            <span class="material-icons copyto-clipboard-btn-layer ${isText}" title="Copy SVG To Clipboard">content_paste</span>
            <span class="material-icons toggle-visibility-layer ${visible}" title="Toggle Visibility">${visible_class}</span>
            <span class="material-icons delete-btn-layer" title="Delete Layer">delete</span>
        `;
        wrapper.appendChild(listItem);

        // Container for children
        const childrenContainer = document.createElement('div');
        childrenContainer.classList.add('layer-children');
        wrapper.appendChild(childrenContainer);

        container.appendChild(wrapper);

        if (item.getClassName() === 'Group' && item.children) {
          addItems(item.children, childrenContainer, level + 1);
        }

        layerIdx++;
      });
    }

    addItems(items, listContainer);

    const listItems = document.querySelectorAll('.list-item-layer');
    const wrappers = document.querySelectorAll('.layer-group-wrapper');
    let draggedItem = null;
    let selectedItem = null;

    // Selection Logic (remains on list-item-layer)
    listItems.forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target.classList.contains('delete-btn-layer') ||
          e.target.classList.contains('copyto-clipboard-btn-layer') ||
          e.target.classList.contains('drag-handle-layer') ||
          e.target.classList.contains('toggle-visibility-layer'))
          return;

        if (selectedItem) {
          selectedItem.classList.remove('selected');
        }
        item.classList.add('selected');
        this.selectNodeById(parseInt(item.getAttribute("data-id")));
        selectedItem = item;
      });

      // Delete functionality
      const deleteBtn = item.querySelector('.delete-btn-layer');
      deleteBtn.addEventListener('click', () => {
        if (item === selectedItem) {
          selectedItem = null;
        }
        this.deleteNodeById(parseInt(item.getAttribute("data-id")));
        item.closest('.layer-group-wrapper').remove();
      });

      // Copy SVG data to clipboard functionality
      const copySVGBtn = item.querySelector('.copyto-clipboard-btn-layer');
      copySVGBtn.addEventListener('click', () => {
        let curNode = this.getNodeById(parseInt(item.getAttribute("data-id")));

        if (curNode && curNode.copySVGDataToClipboard) {
          curNode.copySVGDataToClipboard();
        }
      });

      // Visibility toggle functionality
      const toggleBtn = item.querySelector('.toggle-visibility-layer');
      toggleBtn.addEventListener('click', () => {
        toggleBtn.classList.toggle('layer-hidden');
        toggleBtn.innerText = toggleBtn.innerText === "visibility" ? "visibility_off" : "visibility";

        let curNode = this.getNodeById(parseInt(item.getAttribute("data-id")));
        if (curNode) {
          if (curNode.visible() === true) {
            curNode.hide();
            this.selectNone();
          } else {
            curNode.show();
            this.selectNode(curNode);
          }
        }
      });

    });

    // Drag and drop functionality (on wrappers)
    wrappers.forEach(item => {
      item.addEventListener('dragstart', (e) => {
        e.stopPropagation(); // Prevent bubbling
        draggedItem = item;
        // Select content
        const content = item.querySelector('.list-item-layer');
        if (selectedItem) selectedItem.classList.remove('selected');
        if (content) {
          content.classList.add('selected');
          selectedItem = content;
        }

        setTimeout(() => {
          item.classList.add('dragging');
        }, 0);
      });

      item.addEventListener('dragend', () => {
        item.classList.remove('dragging');

        // Re-sort Konva nodes
        const syncOrder = (container) => {
          Array.from(container.children).forEach(wrapper => {
            if (wrapper.classList.contains('layer-group-wrapper')) {
              const id = parseInt(wrapper.getAttribute('data-id'));
              const node = this.getNodeById(id);
              if (node) {
                // Logic: 
                // 1. Identify new parent (Konva Layer or Group) based on DOM
                const parentContainer = wrapper.parentElement;
                let newParent = this.getLayer(); // Default
                if (parentContainer.classList.contains('layer-children')) {
                  // Parent is a group
                  const parentWrapper = parentContainer.closest('.layer-group-wrapper');
                  const parentId = parseInt(parentWrapper.getAttribute('data-id'));
                  newParent = this.getNodeById(parentId);
                }

                // 2. Move to new parent (handles reparenting)
                if (node.getParent() !== newParent) {
                  node.moveTo(newParent);
                }

                // 3. Move to bottom (which is effectively "next" in draw order)
                // Since we traverse DOM top-to-bottom, this sorts them correctly.
                node.moveToTop();

                // Recurse
                const childrenContainer = wrapper.querySelector('.layer-children');
                if (childrenContainer) {
                  this.syncOrder(childrenContainer);
                }
              }
            }
          });
        };

        this.syncOrder(listContainer);
        this.getLayer().batchDraw();
        draggedItem = null;
      });

      item.addEventListener('dragover', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      item.addEventListener('dragenter', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Logic for insertion
        const targetWrapper = e.target.closest('.layer-group-wrapper');
        if (targetWrapper && targetWrapper !== draggedItem && !draggedItem.contains(targetWrapper)) {
          // Simple insertion before/after logic
          // To allow dropping "inside", we might need hit testing or zones.
          // For now, let's assume dropping *on* a wrapper puts it before/after (sibling).

          const bounding = targetWrapper.getBoundingClientRect();
          const offset = bounding.y + (bounding.height / 2);
          const parent = targetWrapper.parentNode;

          if (e.clientY - offset > 0) {
            parent.insertBefore(draggedItem, targetWrapper.nextSibling);
          } else {
            parent.insertBefore(draggedItem, targetWrapper);
          }
        }
      });
    });
  }


  getSortableNodes() {
    //let sortable = layer.children.filter(node => node.attrs.sortable === true);
    let sortable = this.getLayer().children.filter(node => node.getClassName() !== "Transformer" && node.attrs.type !== "baseImage");
    return sortable;
  }


  getSelectedNode() {
    return this.selectedNode;
  }


  deleteNode(obj) {
    if (obj) {
      obj.destroy();
      this.selectNone();
    }
  }


  deleteNodeById(id) {
    let node = this.getNodeById(id);
    if (node) {
      this.deleteNode(node);
    }
  }


  getImageLayers() {
    let ret = new Array();

    this.getLayer().children.forEach((obj) => {
      if (obj.attrs.type === "svgobject" || obj.attrs.type === "imageupload") {
        ret.push(obj);
      }
    });

    return ret;
  }


  deleteAllNodes() {
    let delNodes = Array();
    let items = this.getLayer().getChildren();

    items.forEach((item) => {
      if (item.className !== "Transformer") {
        delNodes.push(item);
      }
    });

    delNodes.forEach((node) => {
      node.destroy();
    });
  }


  getTrack() {
    var matched = this.getLayer().getChildren(function (node) {
      return node.attrs.type === "svgobject" && node.attrs.group === "Tracks";
    });

    if (matched && matched.length) {
      matched = matched[0];
    } else {
      matched = null;
    }

    return matched;
  }


  getParts() {
    var matched = this.getLayer().getChildren(function (node) {
      return node.attrs.type === "svgobject" && node.attrs.group === "Parts";
    });

    if (matched && matched.length) {
      matched = matched[0];
    } else {
      matched = null;
    }

    return matched;
  }


  destroyTrack() {
    let track = this.getTrack();
    if (track) {
      track.destroy();
      this.selectNone();
    }
  }


  resetTrackIndex() {
    let track = this.getTrack();
    if (track) {
      track.setZIndex(1);
    }
  }


  checkBoard() {
    if (!this.getBaseLayer()) { 
      showMessage("Notice", "You must select a Cribbage board first"); 
      return false; 
    }

    return true;
  }


  getNodeIndex(input) {
    let node = input;
    if (typeof input === 'number' || typeof input === 'string') {
      node = this.getNodeById(input);
    }

    if (node) {
      return node.zIndex();
    }
    return -1;
  }


  getNodeById(id) {
    const findRecursive = (parent) => {
      if (parent._id === id) return parent;
      if (parent.children) {
        for (let child of parent.children) {
          let res = findRecursive(child);
          if (res) return res;
        }
      }
      return null;
    }
    return findRecursive(this.getLayer());
  }


  getNextNode(node) {
    let nodeIdx = this.getNodeIndex(node) + 1;

    if (nodeIdx == this.getLayer().children.length) {
      nodeIdx == this.getFirstSelectableNodeIndex();
      //console.log("nodeIdx-1", nodeIdx);
      if (nodeIdx == -1) {
        nodeIdx = null;
      }
      //console.log("nodeIdx-2", nodeIdx);
      this.selectNode(nodeIdx);
    }
  }


  getFirstSelectableNodeIndex() {
    let idx = -1;
    let pos = 0;

    this.getLayer().children.forEach(item => {
      if ((item.getClassName() !== "Image" && item.attrs.type !== "baseImage") && item.getClassName() != "Transformer") {
        if (idx === -1) {
          idx = pos;
        }
      }
      pos++;
    });

    return idx;
  }


  getCanAddTrack() {
    let ret = false;

    if (this.getBaseLayer()) {
      let name = this.getBaseLayer().getAttrs().name;

      this.getCustomizerBoards().forEach(board => {
        if (board.board_image == name) {
          ret = board.can_choose_track;
        }
      });
    }

    return ret;
  }


  getLayerByClassName(className) {
    return this.getLayer().children.find((item) => item.className === className);
  }


  getTrackNode() {
    var matched = this.getLayer().getChildren(function (node) {
      return node.attrs.type === "svgobject" && node.attrs.group === "Tracks";
      //return node.getClassName() === "Track";
    });

    if (matched && matched.length) {
      matched = matched[0];
    } else {
      matched = null;
    }

    return matched;
  }


  getBaseNode() {
    var matched = this.getLayer().getChildren(function (node) {
      return node.getClassName() === "Image" && node.attrs.type === "baseImage";
      //return node.getClassName() === "BaseLayer";
    });

    if (matched && matched.length) {
      matched = matched[0];
    } else {
      matched = null;
    }

    return matched;
  }


  getCanMoveNodeDown(node) {
    return node.zIndex() > 1;
  }

  getCanMoveNodeUp(node) {
    return node.zIndex() != 0 && ((node.zIndex() + 1) < (this.getLayer().children.length - this.countTransformersNodes()));
  }


  moveNodeDown(node) {
    if (this.getCanMoveNodeDown(node)) {
      node.zIndex(node.zIndex() - 1);
    }
  }


  moveNodeUp(node) {
    if (this.getCanMoveNodeUp(node)) {
      node.zIndex(node.zIndex() + 1);
    }
  }


  moveSelectedNodeDown() {
    this.moveNodeDown(this.getSelectedNode());
  }


  moveSelectedNodeUp() {
    this.moveNodeUp(this.getSelectedNode());
  }


  getTransformersNodes() {
    let transformers = this.getLayer().children.filter(node => node.getClassName() === "Transformer");
    return transformers;
  }


  getCountTransformersNodes() {
    return this.getTransformersNodes().length;
  }


  getNextNodePos() {
    let pos = this.getLayer().children.length - this.getCountTransformersNodes() - 1;
    if (pos < 0) {
      pos = 0;
    }

    return pos;
  }


  applyStain(color) {
    let that = this;

    stainFilters.forEach(stain => {
      if (stain.name == color) {
        let node = that.getLayer();

        node.filters([]);
        that.getLayer().batchDraw();
        node.cache();

        if (color !== "Clear") {
          node.filters([Konva.Filters.RGB]);
          node.red(stain.red);
          node.blue(stain.blue);
          node.green(stain.green);
        }

        that.getLayer().batchDraw();
      }
    });
  }
  

  initStains() {
    let dialog = document.getElementById("stainDialog");
    let copyBlock = document.querySelector("#stainDialog #messageCopy");

    stainFilters.forEach(stain => {
      let link = document.createElement('a');
      link.setAttribute("data-color", stain.name);
      link.classList.add('stain-link');
      link.innerHTML = stain.name;

      link.addEventListener('click', function () {
        this.applyStain(stain.name);
      }.bind(this));

      copyBlock.appendChild(link);
    });
  }


  getDesignLayerPrices() {
    let layers = new Array();
    let textCount = 0;
    let base_price = this.getBoard().base_price;
    let final_price = 0;

    layers.push({
      "layer": "base",
      "type": "board",
      "cost": base_price
    });

    for (let l = 0; l < this.getLayer().children.length; l++) {
      if (this.getLayer().children[l].attrs.type == "image" ||
        this.getLayer().children[l].attrs.type == "imageupload" ||
        this.getLayer().children[l].attrs.type == "svgobject" ||
        (this.getLayer().children[l].attrs.type == "text" || this.getLayer().children[l].attrs.type == "textpath")) {
        layers.push({
          "layer": l,
          "type": this.getLayer().children[l].attrs.type,
          "group": this.getLayer().children[l].attrs.group,
          "cost": this.calculateLayerCost(this.getLayer().children[l]),
        });
      }
    }

    return layers;
  }


  calculateDesignCost() {
    if (!this.getBoard()) return 0;
    
    let layers = new Array();
    let textCount = 0;
    let base_price = this.getBoard().base_price + (this.getBoard().board_foot * this.boardDimensions.boardFeet.total);
    let final_price = 0;

    layers.push({
      "layer": "base",
      "type": "board",
      "cost": base_price
    });

    const processNode = (node) => {
      if (node.getClassName() === 'Group' && node.children) {
        node.children.forEach(child => processNode(child));
        return;
      }

      if (node.attrs.type == "image" ||
        node.attrs.type == "imageupload" ||
        node.attrs.type == "svgobject" ||
        node.attrs.type == "svgupload" ||
        node.attrs.type == "text") {
        //((node.attrs.type == "text" || node.attrs.type == "textpath") && textCount++ >= 0)) {
        layers.push({
          "layer": node._id,
          "type": node.attrs.type,
          "group": node.attrs.group,
          "cost": this.calculateLayerCost(node),
        });
      }
    };

    this.getLayer().children.forEach(child => processNode(child));

    //console.log("Layer Costs", layers);

    for (let l = 0; l < layers.length; l++) {
      final_price += layers[l].cost;
    }

    return final_price;
  }


  calculateLayerCost(node) {
    let ret = 0;

    if (node.getClassName() !== "Cutout") {
      if (node.getClassName().toLowerCase().includes("text")) {
        if (node.getAttr('text').trim().length < 75) {
          ret = 10;
        } else {
          ret = Math.abs(Math.round((node.getAttr('text').trim().length / 75) * 10), 2);
        }
      } else if (node.getAttr('group') !== "Tracks") {

        let width = node.getWidth() * node.getScaleX() / this.getBaseLayerScale() / DPI;
        let height = node.getHeight() * node.getScaleY() / this.getBaseLayerScale() / DPI;
        ret = Math.abs(Math.round((width * height * CPM), 2));

      } else {

        let lanes = parseInt(node.getAttr('numberLanes'));
        if (isNaN(lanes)) {
          lanes = 4;
        }
        ret = lanes * perLane;
      }
    }

    return ret;
  }


  getBaseLayerScale() {
    let scale = 1.0;

    if (this.getBaseLayer())
      scale = this.getBaseLayer().getScale().x;

    return scale;
  }

  
  flipHorizontal(obj) {
    if (obj && obj.attrs.group != "Tracks") {
      obj.setScaleX(-obj.getScaleX())
    }
  }
  

  flipVertical(obj) {
    if (obj && obj.attrs.group != "Tracks") {
      obj.setScaleY(-obj.getScaleY())
    }
  }


  addTrackImage(imageUrl, dataset = {}) {
    console.log("addTrackImage", imageUrl, dataset);
    let that = this;
    
    Konva.Image.fromURL(imageUrl, function (imgNode) {
      imgNode.setAttrs({
        x: 100,
        y: 100,
        width: imgNode.width(), // * (72/96),
        height: imgNode.height(), // * (72/96),
        draggable: false,
        isFlipped: false,
        name: imageUrl,
        type: dataset.type,
        group: dataset.group,
        numberLanes: dataset.lanes,
        sortable: dataset.group === "Tracks" ? false : true,
      });

      imgNode.className = "Track";

      imgNode.cache();
      imgNode.filters([Konva.Filters.Grayscale]);

      that.getLayer().add(imgNode);
      that.selectNode(imgNode);

      that.getLayer().batchDraw();
    }, function (err) {
      console.error('Error loading image:', err);
    }.bind(this));
  }


  deleteAllObjects() {
    let delNodes = Array();
    let items = this.getLayer().getChildren();

    items.forEach((item) => {
      if (item.className !== "Transformer" && item.attrs.type != "baseImage") {
        delNodes.push(item);
      }
    });

    //console.log("function: deleteAllObjects");
    //console.log("delNodes", delNodes);

    delNodes.forEach((node) => {
      node.destroy();
    });

    this.selectNone();
  }


  initDropZone() {
    //dropZone = document.getElementById("app-container");
    this.setDropZone(document.querySelector(".main-content"));

    this.getDropZone().addEventListener('dragover', (e) => {
      e.preventDefault(); // Prevent default opening of dropped files
      e.stopPropagation(); // Stop event propagation
      e.dataTransfer.dropEffect = 'copy'; // Visual cue for copying
    });

    this.getDropZone().addEventListener('dragleave', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    this.getDropZone().addEventListener('drop', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const files = e.dataTransfer.files; // FileList object of dropped files

      if (files.length > 0) {
        // Process the files, e.g., upload them
        this.handleDropFileUpload(files);
      }
    });
  }


  handleDropFileUpload(files) {
    //console.log("handleDropFileUpload", files);

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i]); // Append each file
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      //console.log("Processing file:", file.name, file.type, file.size);

      // Check if the file type is an image
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/webp" &&
        file.type !== "image/svg+xml"
      ) {
        //console.error("not a valid file image type");
        return;
      }

      const reader = new FileReader();

      // What to do when the file is successfully read
      reader.onload = (e) => {
        const fileContents = e.target.result;

        if (file.type === "image/svg+xml") {
          //img = fileContents;
          addSvgImage(arrayBufferToUtf8String(fileContents), 60 + this.getBaseLayer().width() / 2, 60 + this.getBaseLayer().height() / 2);
          return;
        }

        const blob = new Blob([fileContents], { type: file.type });
        const imageUrl = URL.createObjectURL(blob);
        let img = new Image();

        img.onload = () => {
          let loadedImage = null;

          // 5. Create Konva.Image after HTMLImageElement is loaded
          loadedImage = new Konva.Image({
            x: 60 + this.getBaseLayer().width() / 2,
            y: 60 + this.getBaseLayer().height() / 2,
            image: img,
            width: img.width, // Use original image dimensions
            height: img.height,
            draggable: false,
            name: "uploadedImage",
            type: "imageupload",
          });

          loadedImage.attrs.imageURI = loadedImage.toDataURL();

          // Optional: Scale down if image is too large for the stage
          const maxDimension = Math.max(img.width, img.height);
          const stageMax = Math.min(this.getStage().width(), this.getStage().height());
          if (maxDimension > stageMax * 0.8) {
            // If image is larger than 80% of stage
            const scale = (stageMax * 0.8) / maxDimension;
            loadedImage.width(img.width * scale);
            loadedImage.height(img.height * scale);
          }

          loadedImage.offset({
            x: loadedImage.width() / 2,
            y: loadedImage.height() / 2,
          });

          this.getLayer().add(loadedImage);
          loadedImage.filters([
            Konva.Filters.Grayscale,
            Konva.Filters.WhiteToTransparent,
          ]);
          loadedImage.cache();
          this.getLayer().draw();

          //layer.children[layer.children.length-1].moveToBottom();
          //layer.children[0].moveUp();

          this.selectNode(loadedImage);

          // IMPORTANT: Revoke the Object URL to release memory when the image is no longer needed
          // or when the page is unloaded. For this example, we'll revoke it immediately
          // as the HTMLImageElement has now loaded the data. If you needed the URL
          // for other purposes, you might revoke it later.
          URL.revokeObjectURL(imageUrl);
        };

        img.onerror = () => {
          statusDiv.textContent = "Error loading image from URL.";
          statusDiv.classList.add("error");
          URL.revokeObjectURL(imageUrl); // Revoke even on error
        };

        img.src = imageUrl; // Set the image source

        document.getElementById("imageFileInput").value = "";
      };

      // What to do if an error occurs during reading
      reader.onerror = (e) => {
        console.error("FileReader error:", reader.error);
      };

      // Read the file as binary
      reader.readAsArrayBuffer(file);
    }

  }


}



const app = new DesignerApp();
window.app = app;
